export default __webpack_public_path__ + "static/media/logo.0f8b5a1a.png";